import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import {
    QUERY_KEYS_UR,
    useChartsData
} from '../../../../Common/hooks/useChartsData';

export const TradicionalGroupsChartsDataContext = createContext();

const TradicionalGroupsChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_UR.TRADICIONAL_GROUPS_FAMILIES,
            url: 'governanceroom/dashboard/unifiedregistry/families/traditional-groups'
        },
        {
            location: filters.unidade.value,
            city: filters.cidade?.value,
        }
    );

    const chartData = data
        ? {
              indicators: {
                  tradicionalGroups: data?.indicators?.tradicionalGroups ?? 0,
                  traditionalGroupsTotal: data?.indicators?.traditionalGroupsTotal ?? 0,
              },
              familiesPerIndigenousGroup:
                  data?.familiesPerIndigenousGroup ?? [],
              familiesPerIndigenousReservation:
                  data?.familiesPerIndigenousReservation ?? [],
              familiesPerQuilombolaComunity:
                  data?.familiesPerQuilombolaComunity ?? [],
              indigenousFamily: data?.indigenousFamily ?? [],
              indigenousReservation: data?.indigenousReservation ?? [],
              quilombolaFamily: data?.quilombolaFamily ?? []
          }
        : {
            indicators: {
                tradicionalGroups: 0,
                traditionalGroupsTotal: 0,
            },
              familiesPerIndigenousGroup: [],
              familiesPerIndigenousReservation: [],
              familiesPerQuilombolaComunity: [],
              indigenousFamily: [],
              indigenousReservation: [],
              quilombolaFamily: []
          };

    return (
        <TradicionalGroupsChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </TradicionalGroupsChartsDataContext.Provider>
    );
};

export default TradicionalGroupsChartsDataProvider;
